import React from "react";
import { Container, StyledIcon, CartWrap, CountBubble } from "./styles";
import { useTheme } from "styled-components";
import {
  useSearchDrawer,
  useCartDrawer,
  useMobileMenu,
  useCartCount,
} from "src/context/siteContext";

export interface Props {
  marginTop: boolean;
}

const Actions = ({ marginTop }: Props) => {
  const { openSearch } = useSearchDrawer();

  const { openCart } = useCartDrawer();
  const { openMenu } = useMobileMenu();
  const count = useCartCount();
  const theme = useTheme();

  return (
    <Container marginTop={marginTop}>
      <StyledIcon
        name="search"
        onClick={openSearch}
        color={theme.colors.font_white}
      />

      <CartWrap onClick={openCart}>
        <StyledIcon name="shopping-cart" />
        {count > 0 && <CountBubble />}
      </CartWrap>

      <StyledIcon name="burger" onClick={openMenu} />
    </Container>
  );
};

export default Actions;
